import React from "react";
import { PieChart } from "react-minimal-pie-chart";

const Chart = ({ data }) => {
  var d = data.filter((d) => d.value > 0);
  //paddingRight: "15px",
  //paddingTop: "5px",
  return (
    <PieChart
      data={d}
      style={{
        height: "85px",
        fontFamily:
          '"Nunito Sans", -apple-system, Helvetica, Arial, sans-serif',
        fontSize: "8px",
      }}
      lineWidth={60}
      segmentsStyle={{ transition: "stroke .3s", cursor: "pointer" }}
      label={({ dataEntry }) => dataEntry.value}
      labelPosition={100 - 60 / 2}
      labelStyle={{
        fill: "#000",
        opacity: 0.75,
        pointerEvents: "none",
        textShadow: " 10px 10px 20px black",
      }}
    />
  );
};

const UserTooltip = ({ user, position, wars }) => {
  var warNotIn = 0;
  var warMissed = 0;
  var warPartial = 0;
  var warFull = 0;
  var warPerfect = 0;
  var attMissed = 0;
  var attStars = [0, 0, 0, 0];
  var anyWar = false;

  for (var i = 0; i < user.days.length; i++) {
    var war = wars[i];
    var day = user.days[i];
    if (war != null) {
      let na = war.numAttacks;
      let at = day.attacks;
      if (at === na) {
        if (day.stars === 3 + (3 << 3)) warPerfect++;
        else warFull++;
      } else if (at > 0) warPartial++;
      else if (at === 0) warMissed++;
      else if (at === -1) warNotIn++;

      if (at >= 0) {
        attMissed += na - at;
        anyWar = true;
      }
      var st = day.stars;
      for (var j = 0; j < at; j++) {
        attStars[st % 8]++;
        st = st >> 3;
      }
    }
  }

  return (
    <div
      className="usertooltip"
      style={{ top: position.top, left: position.left }}
    >
      <div className="flexcolumn">
        <div className="usertitle">
          {user.id.name}
          {user.role > 1 ? (
            <img
              src={"roles/role" + user.role + ".png"}
              alt={"role " + user.role}
              width="20px"
              height="20px"
            />
          ) : null}
        </div>
        <div className="userid">{user.id.tag}</div>
        {user.thLevel > 0 ? (
          <img
            src={
              "th/th" +
              user.thLevel.toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              }) +
              ".png"
            }
            alt={"Townhall " + user.thLevel}
            width="100px"
            height="100px"
          />
        ) : null}
        {user.role === 0 ? null : (
          <table>
            <tbody>
              <tr>
                <td>Trophies:</td> <td>{user.trophies}</td>
              </tr>
              <tr>
                <td>Donated:</td> <td>{user.donations}</td>
              </tr>
              <tr>
                <td>Received:</td> <td>{user.donationsReceived}</td>
              </tr>
              <tr>
                <td>Exp.level:</td> <td>{user.expLevel}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
      <div className="charts">
        <Chart
          data={[
            { title: "Not in war", value: warNotIn, color: "#87CEFA" },
            { title: "Missed attacks", value: warMissed, color: "#ff0000" },
            { title: "Partial attacks", value: warPartial, color: "#ffa500" },
            { title: "Full attacks", value: warFull, color: "#008000" },
            { title: "Perfect attacks", value: warPerfect, color: "#00A000" },
          ]}
        />
        {anyWar ? (
          <Chart
            data={[
              { title: "missed", value: attMissed, color: "#ff0000" },
              { title: "no star", value: attStars[0], color: "#707070" },
              { title: "*", value: attStars[1], color: "#808000" },
              { title: "**", value: attStars[2], color: "#b0b000" },
              { title: "***", value: attStars[3], color: "#ffff00" },
            ]}
          />
        ) : null}
      </div>
    </div>
  );
};

export default UserTooltip;
